import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const globalSearch = (query) => {
 
  return axios.get(API + "helper/global-search/?query="+query,{headers: authHeader(),});
};
const GlobalSearchService = {
    globalSearch,
  };
  export default GlobalSearchService;